import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import SaVoucherInfo, {
  SaVoucherNotice,
} from '@/components/Approval/@components/SaVoucherInfo';
import {
  parseLegacyVoucherContent,
  parseSaVoucherAttributes,
} from '@/utils/approval/saVoucher';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/**
 * 99 SA 전표 — 저장 시점 스냅샷(attributes.vouchers)으로 표를 그림. SAP 재조회 안 함(결재 당시 값 보존).
 * 레거시 작성 문서는 스냅샷이 없어 attributes.content 의 전표 표 HTML 에서 텍스트만 읽음
 */
const SaVoucherSlot = ({ data }: ContentExtraProps) => {
  const { t } = useTranslation();
  const voucher = useMemo(
    () => parseSaVoucherAttributes(data.attributes),
    [data.attributes],
  );
  const legacy = useMemo(
    () =>
      voucher && !voucher.hasVoucherSnapshot
        ? parseLegacyVoucherContent(voucher.content)
        : null,
    [voucher],
  );

  if (!voucher) return null;

  const title = t('전표 정보');
  const vouchers = legacy?.vouchers ?? voucher.vouchers;

  return (
    <ContentSlotRoot>
      {vouchers.length ? (
        <SaVoucherInfo
          title={title}
          vouchers={vouchers}
          zSum={voucher.zSum}
          companyName={legacy?.companyName}
        />
      ) : (
        <SaVoucherNotice
          title={title}
          message={t('전표 정보를 표시할 수 없습니다.')}
        />
      )}
    </ContentSlotRoot>
  );
};

export default SaVoucherSlot;
